<template>
  <div :class="$style.wrap">
    <div :class="[$style.info, 'van-hairline--bottom']">
      欢迎回来，{{ userInfo.login_code }}
      <button :class="$style.exit" @click="onExit">安全退出</button>
    </div>
    <van-cell
      is-link
      :title="_anchor.bindPhone.title"
      :to="_anchor.bindPhone.path"
      :border="false"
      :class="[$style.menu, phone && $style['menu-complete']]"
    >
      <template v-slot:icon>
        <div :class="[$style.icon, , $style['icon-phone']]" />
      </template>
      {{ phone ? phone : "绑定" }}
    </van-cell>
    <van-cell
      is-link
      :title="_anchor.identity.title"
      :to="_anchor.identity.path"
      :border="false"
      :class="[$style.menu, isIdentity && $style['menu-complete']]"
    >
      <template v-slot:icon>
        <div :class="[$style.icon, $style['icon-card']]" />
      </template>
      {{ isIdentity ? "已认证" : "认证" }}
    </van-cell>
    <van-cell
      is-link
      :title="_anchor.password.title"
      :to="_anchor.password.path"
      :border="false"
      :class="[$style.menu]"
    >
      <template v-slot:icon>
        <div :class="[$style.icon, $style['icon-lock']]" />
      </template>
    </van-cell>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Profile",
  computed: {
    ...mapGetters(["userInfo"]),
    phone() {
      return this.userInfo.security_telphone || "";
    },
    isIdentity() {
      return this.userInfo.name && this.userInfo.id_code;
    }
  },
  methods: {
    ...mapActions(["Logout", "SetHeaderShow"]),
    /**
     * @description 退出
     */
    onExit() {
      this.Logout(true).then(() => {
        this.SetHeaderShow(false);
        this.$route.name !== "index" &&
          this.$router.replace({ path: this._anchor.index.path });
      });
    }
  }
};
</script>

<style lang="less" module>
.wrap {
  margin: 0 @cell-horizontal-padding;
}

.info {
  padding: 1.23rem 0 @padding-xl;
  font-size: 0.28rem;
}

.menu {
  align-items: center;
  margin-top: @padding-xl;
  border-radius: 0.1rem;
  background-color: @white;
  box-shadow: 0.09rem 0.09rem 0.16rem fade(@black, 6%);

  :global {
    .van-cell__value {
      color: #1b8cff;
    }
  }

  &-complete {
    :global {
      .van-cell__value {
        color: @cell-value-color;
      }
    }

    .icon {
      &::after {
        background-position: 100% 0;
      }
    }
  }
}

.icon {
  .size(0.87rem);
  position: relative;
  margin-right: @padding-md;
  background: url("./images/icon-menu.png") no-repeat;
  background-size: 100% 300%;

  &-phone {
    background-position: 0 0;
  }

  &-card {
    background-position: 0 50%;
  }

  &-phone::after,
  &-card::after {
    content: "";
    .size(0.3rem);
    position: absolute;
    right: -0.07rem;
    bottom: 0.04rem;
    background: url("./images/icon-check.png") no-repeat;
    background-size: 200% 100%;
  }
  &-lock {
    background-position: 0 100%;
  }
}
.exit {
  margin-left: 1.5em;
  padding: 0.25em 1em;
  border: 1px solid rgb(72, 213, 175);
  border-radius: 1em;
  background-color: @white;
  color: rgb(72, 213, 175);
}
</style>
